<template>
  <div class="sign_in" style="background-color: #fff" ref="form">
    <div class="title" style="padding: 15px 0px 5px 0px" xs12>
      <div style="width: 100%; height: 52px; text-align: center">
        <img style="width: 50px; height: 50px" @click="addClickTimes()" src="imgs/svg/my/logo.png" />
      </div>
      <div style="text-align: center; margin-top: 5px">
        <span class="login_span">{{ displayName }}</span>
      </div>
    </div>
    <v-text-field name="phoneNumber" style="width: 85%; margin-left: 7.5%; margin-top: 20px" flat
      :label="$t('手机号/邮箱地址')" single-line validate-on-blur
      :rules="__privacyGuidelines ? [] : [rules.required, rules.phoneMatch]" v-model="phoneNumber" :append-icon="phoneNumberHistory.number.length != 0 ? 'arrow_drop_down' : ''
        " @click:append="showHistory()" ref="phoneNumber" tabindex="1" required clearable @keydown="focus2password()"
      type="text" autocomplete="off"></v-text-field>

    <div class="phone-number-history theme--light" v-show="phoneNumberHistory.visible">
      <template>
        <div class="phone-number" v-for="(number, index) in phoneNumberHistory.number" :key="index"
          @click="(e) => selectNumber(e, number)">
          <span>{{ number }}</span>
          <div class="clear-icon">
            <v-icon @click="(e) => clearHistoryNumber(e, number)">clear</v-icon>
          </div>
        </div>
      </template>
    </div>

    <div>
      <v-text-field ref="password" name="password" style="width: 85%; margin-left: 7.5%" flat :label="$t('密码')"
        single-line validate-on-blur v-model="password" :rules="[rules.required]" type="password" required clearable
        tabindex="2" @focus="go2login()" @keydown="focus2login()"></v-text-field>
      <p class="forgot" @click="Change2Regcode">{{ $t('首次登录或忘记密码?') }}</p>
    </div>

    <v-flex style="width: 90%; margin-left: 5%">
      <v-btn :loading="loading3" tabindex="3" class="login" color="primary" @click="Login">{{ $t('登录') }}</v-btn>
    </v-flex>
    <div class="licence-wrap">
      <v-checkbox color="blue" v-model="__isAgreeLicence"></v-checkbox>
      <span class="licence-text">{{ $t('我已阅读并同意') }}</span>
      <span class="licence-link" @click="showLicense()">{{ $t('《软件许可与服务协议》') }}</span>
      <span class="licence-text">{{ $t('和') }}</span>
      <span class="licence-link" @click="showPrivacy()">{{ $t('《隐私政策》') }}</span>
    </div>
    <!-- 多语言切换 -->
    <eDSCompLanguage />

    <eds-copyright v-if="platform === 'browser'" :beian="true" />

    <template v-if="__privacyGuidelines && platform && platform !== 'browser'">
      <v-dialog :value="!thinkAgain" persistent max-width="500" content-class="privacy-guidelines-dlg">
        <v-card>
          <v-card-title class="headline">{{ $t('隐私保护指引') }}</v-card-title>
          <v-card-text ref="privacy-guidelines__content">
            <div>
              {{ $t('欢迎您使用') }}{{
              displayName
              }}！{{ $t('我们非常重视保护您的个人信息，请仔细阅读并理解我们的') }}<span class="licence-link" @click="showPrivacy()">{{ $t('《隐私政策》')
                }}</span>，{{ $t('请重点关注如下：') }}
            </div>
            <div>
              {{ $t('1、为向您提供数字化办公、沟通与协同相关基本功能，我们可能会收集、使用必要的信息；') }}
            </div>
            <div>
              {{ $t('2、我们可能会根据您的使用场景并经您同意后向您获取系统权限，如存储权限等；') }}
            </div>
            <div>{{ $t('3、我们会采取业界先进的安全措施保护您的信息安全；') }}</div>
            <div>
              {{ $t('4、未经您同意，我们不会从第三方处获取、共享或向其提供您的信息。') }}
            </div>
          </v-card-text>
          <v-card-actions style="height:120px">
            <v-btn color="blue darken-1" @click="__privacyGuidelines = false">{{ $t('同意') }}</v-btn>
            <v-btn flat @click="thinkAgain = true">{{ $t('不同意') }}</v-btn>
            <!-- 多语言切换 -->
            <eDSCompLanguage />
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog :value="thinkAgain" persistent max-width="500" content-class="privacy-guidelines-think-again-dlg">
        <v-card>
          <v-card-text>
            <div>{{ $t('您需要同意隐私政策才能继续使用') }}{{ displayName }}</div>
            <div>{{ $t('若您不同意本隐私政策，很遗憾我们将无法为您提供服务。') }}</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="exitApp">{{ $t('退出应用') }}</v-btn>
            <v-btn color="primary" flat @click="thinkAgain = false">{{ $t('查看协议') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import edsCopyright from './edsCopyright'
import { mapGetters, mapActions, mapState, mapMutations } from 'vuex'
import axios from 'axios'
import { URLS } from '../util/urls'
import msgbus from '../msgBus'
import operations from '../operations'
import funcListConfig from '../funcListConfig'
import tools from '../util/tools'
import devHelper from '../util/devHelper'
import dbHelper from '../util/db'
import debugHelper from '../util/debug'
import isTest from '../util/urltest'
import eDSCompLanguage from '../components/eDSCompLanguage.vue'
import i18n from '../lang/index'

export default {
  name: 'iDS-PwdLogin',
  components: {
    edsCopyright,
    eDSCompLanguage,
  },
  data: function () {
    return {
      isAgreeLicence: false, // 标识是否同意服务协议
      privacyGuidelines: true, // 隐私保护指引
      thinkAgain: false, // 再想想？
      phoneNumber: '',
      isRemember: true,
      password: '',
      licence: '',
      formHasErrors: false,
      rules: {
        required: (v) => !!v || this.$t('该项不能为空'),
        phoneMatch: (phone) =>
          /^1\d{10}$/.test(phone) ||
          /^((?:\w+-*\.?)+)@((?:\w+-*)+(\.(?:\w+-*))+)+$/.test(phone) ||
          this.$t('请输入正确的手机号或邮箱地址'),
      },
      loader: null,
      loading3: false,
      phoneNumberHistory: {
        visible: false,
        number: [],
      },
      isTest: isTest,
    }
  },

  computed: {
    ...mapGetters('app', ['displayName', 'platform']),
    form() {
      return {
        phoneNumber: this.phoneNumber,
        password: this.password,
      }
    },
    __isAgreeLicence: {
      get() {
        return this.isAgreeLicence
      },
      set(value) {
        this.isAgreeLicence = value
        dbHelper.set('isAgreeLicence', this.isAgreeLicence)
      },
    },
    __privacyGuidelines: {
      get() {
        return this.privacyGuidelines
      },
      set(value) {
        this.privacyGuidelines = value
        dbHelper.set('privacyGuidelines', this.privacyGuidelines)
        if (!this.privacyGuidelines) {
          if (this.$refs.phoneNumber) {
            this.$refs.phoneNumber.focus()
          }
        }
      },
    },
  },
  watch: {
    loader() {
      const l = this.loader
      this[l] = !this[l]

      this.loader = null
    },
    thinkAgain: function (newVal, oldVal) {
      if (!newVal) {
        this.$nextTick(() => {
          if (this.$refs['privacy-guidelines__content']) {
            this.$refs['privacy-guidelines__content'].scrollTop = 0
          }
        })
      }
    },
  },

  methods: {
    exitApp() {
      if (this.platform !== 'browser' && navigator.app) {
        navigator.app.exitApp()
      }
    },
    showLicense() {
      msgbus.vm.setPhoneNumber({ value: this.phoneNumber })
      msgbus.vm.setPassword({ value: this.password })
      this.$router.push({ name: 'licence' })
    },
    showPrivacy() {
      msgbus.vm.setPhoneNumber({ value: this.phoneNumber })
      msgbus.vm.setPassword({ value: this.password })
      this.$router.push({ name: 'privacy' })
    },
    hideHistory() {
      this.phoneNumberHistory.visible = false
    },
    getHistory() {
      var history = dbHelper.get('phoneNumberHistory')
      if (history != null) {
        this.phoneNumberHistory = JSON.parse(history)
        this.phoneNumberHistory.visible = false
      }
    },
    saveHistory() {
      debugHelper.log(this.phoneNumberHistory)
      dbHelper.set(
        'phoneNumberHistory',
        JSON.stringify(this.phoneNumberHistory)
      )
    },
    clearHistoryNumber(e, number) {
      e.stopPropagation()
      var index = this.phoneNumberHistory.number.indexOf(number)
      this.phoneNumberHistory.number.splice(index, 1)
      this.saveHistory()
    },
    selectNumber(e, number) {
      e.stopPropagation()
      this.phoneNumber = number
      this.phoneNumberHistory.visible = !this.phoneNumberHistory.visible
      document.getElementsByTagName('input')[0].focus()
    },
    showHistory() {
      if (this.phoneNumberHistory.number.length != 0) {
        this.phoneNumberHistory.visible = !this.phoneNumberHistory.visible
      } else {
        this.phoneNumberHistory.visible = false
      }
    },
    mSetParams(funcList) {
      var func = funcList[0]
      switch (func.id) {
        case operations.eCreateBottomsByRoles:
          func.params.roles = msgbus.vm.getUserRoles()
          break
      }
      return funcList
    },
    mGetResult(funcList) {
      var func = funcList[0]
      return funcList
    },
    focus2password() {
      this.hideHistory()
      if (event.keyCode == 13) {
        const pwdIndex = 1
        document.getElementsByTagName('input')[pwdIndex].focus()
      }
    },
    focus2login() {
      this.hideHistory()
      if (event.keyCode == 13) {
        this.Login()
      }
    },

    go2login() {
      setTimeout(function () {
        let btnLogin = document.getElementsByClassName('login')[0]
        if (btnLogin) {
          btnLogin.scrollIntoViewIfNeeded(false)
        }
      }, 500)
    },

    go2body() {
      var pwd = document.getElementsByName('password')[0]
      pwd.blur()
      setTimeout(function () {
        document.getElementsByTagName('body')[0].scrollTop = 0
      }, 500)
    },

    Login() {
      var formHasErrors = false
      //检查表单
      Object.keys(this.form).forEach((f) => {
        if (!this.$refs[f].validate(true)) {
          formHasErrors = true
        }
      })
      //有错返回
      if (formHasErrors) {
        return
      }

      if (!this.isAgreeLicence) {
        msgbus.vm.setSnackBar({
          value: {
            color: 'error',
            text: this.$t('请阅读并同意服务协议和隐私政策'),
            visible: true,
          },
        })
        return
      }

      //记住账号
      if (this.isRemember) {
        dbHelper.set('phoneNumber', this.phoneNumber)
        if (
          this.phoneNumberHistory.number.filter(
            (number) => number == this.phoneNumber
          ).length == 0
        ) {
          this.phoneNumberHistory.number.push(this.phoneNumber)
        }
        this.saveHistory()
      } else {
        dbHelper.remove('phoneNumber')
        let index = this.phoneNumberHistory.number.indexOf(this.phoneNumber)
        if (index != -1) {
          this.phoneNumberHistory.number.splice(index, 1)
          this.saveHistory()
        }
      }

      this.loading3 = true
      this.go2body()

      const data = {
        password: this.password,
        vcode: '',
      }
      if (/^1\d{10}$/.test(this.phoneNumber)) {
        data.mobileNo = this.phoneNumber
      } else {
        data.email = this.phoneNumber
      }

      // 登录
      msgbus.vm
        .fetchAuthToken({
          data,
          vm: msgbus.vm,
        })
        .then(
          () => {
            this.loading3 = false

            // 初始化系统
            tools.startFuncList(
              msgbus,
              this,
              funcListConfig.common.initAfterLogin
            )
          },
          () => {
            this.loading3 = false
            return
          }
        )
    },
    Change2Regcode() {
      if (this.phoneNumber) {
        msgbus.vm.setPhoneNumber({ value: this.phoneNumber })
      }
      this.$router.push({ name: 'resetpwd' })
    },
    getLicence() {
      axios({
        method: 'get',
        url: URLS.EDS_LICENCE_URL,
        params: {
          language: i18n.locale,
        },
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + msgbus.vm.getAccountToken(),
        },
      }).then((res) => {
        this.licence = res.data.content
      })
    },

    changeView() {
      msgbus.vm.setTitle('')
      msgbus.vm.setBackDisabled(true)
      msgbus.vm.setBackIcon('')
      msgbus.vm.setBottomNavVisible(false)
      msgbus.vm.setBottomBtnVisible(false)
      msgbus.vm.setMsgInputVisible({ value: false })

      if (!this.phoneNumber) {
        document.getElementsByName('phoneNumber')[0].focus()
      } else {
        document.getElementsByName('password')[0].focus()
      }
    },
  },

  created() {
    console.log('调试代码')

    // 若是“软件许可与服务协议”页面返回，则先判断是否有手机号/密码的设置信息
    this.phoneNumber =
      this.phoneNumber ||
      msgbus.vm.getPhoneNumber() ||
      dbHelper.get('phoneNumber') ||
      ''
    this.password = this.password || msgbus.vm.getPassword()
    // 判断是否开启了测试模式，若是，执行测试代码
    if (devHelper.isDevMode()) {
      if (!this.phoneNumber) {
        this.phoneNumber = '13588893313'
      }
    }
    // 默认勾选记住账号
    this.isRemember = true
    // 读取许可协议标识
    this.isAgreeLicence =
      (dbHelper.get('isAgreeLicence') || 'false') !== 'false'
    // 读取隐私保护指引标识
    if (this.isAgreeLicence) {
      dbHelper.set('privacyGuidelines', false)
    }
    this.privacyGuidelines =
      (dbHelper.get('privacyGuidelines') || 'true') !== 'false'

  },
  mounted() {
    document.body.addEventListener('click', this.hideHistory)
    this.getHistory()
    this.changeView()
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.hideHistory)
    this.saveHistory()
  },
}
</script>

<style lang="scss">
.sign_in {
  .is_remember {
    float: left;
    margin-left: 7.5%;
    margin-top: 0px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #3a3a3a;
    letter-spacing: 0;
  }

  .forgot {
    float: right;
    margin-right: 7.5%;
    margin-top: 0px;
    padding-top: 4px;
    color: blue;
    margin-bottom: 27px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #3a3a3a;
    letter-spacing: 0;
  }

  .phone-number-history {
    position: absolute;
    z-index: 1000;
    font-size: 1.3rem;
    width: 85%;
    margin-left: 7.5%;

    padding: {
      top: 0.5rem;
      bottom: 0.5rem;
    }

    border: {
      left: {
        style: solid;
        width: 2px;
        color: #dddddd;
      }

      right: {
        style: solid;
        width: 2px;
        color: #dddddd;
      }

      bottom: {
        style: solid;
        width: 2px;
        color: #dddddd;
      }
    }

    top: 213px;

    background: white;
    height: 7rem;
    overflow: auto;
    -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);

    .phone-number {
      padding: {
        left: 10px;
      }

      .clear-icon {
        float: right;
        margin-right: 10px;
      }
    }
  }

  h1:first-child {
    width: 100%;
    text-align: center;
    margin-top: -100px;
    margin-bottom: 12px;
  }

  .v-input__slot {
    margin-bottom: 0px;
    border-width: thin;
  }

  .v-text-field {
    margin-bottom: 2px;
  }

  .v-text-field__details {
    margin-top: 4px;
    margin-bottom: 4px;
  }

  button.v-btn.login {
    width: calc(100% - 16px);
  }

  .login_span {
    font-family: PingFangSC-Medium;
    font-size: 17px;
    color: #4a4a4a;
    letter-spacing: 0;
    text-align: center;
  }

  .v-label {
    font-size: 14px;
  }

  .primary {
    background-color: rgb(48, 133, 214) !important;
    border-color: rgb(48, 133, 214) !important;
  }

  input {
    margin-top: 0px !important;
    padding: 6px 0;
  }

  .licence-wrap {
    width: 85%;
    position: relative;
    margin-top: 10px;
    margin-left: 7.5%;

    // text-align: center;
    & .v-input--checkbox {
      display: inline-block;
      margin-top: 0;
      vertical-align: top;

      & .v-input__slot {
        margin-bottom: 0;
      }
    }

    & .licence-link {
      display: inline-block;
      color: #1d80dd;
      font-size: 14px;
      text-align: center;
      vertical-align: top;
      padding-top: 6px;
    }

    & .licence-text {
      display: inline-block;
      color: rgba(0, 0, 0, 0.54);
      font-size: 14px;
      text-align: center;
      vertical-align: top;
      padding-top: 6px;
    }

    & .v-messages {
      min-height: 0;
    }
  }

  &>.eds-copyright {
    position: absolute;
    bottom: 0;
  }
}

.privacy-guidelines-dlg {
  border-radius: 4px;
  margin: 30px;

  &>.v-card {
    padding: 0 20px;

    .v-card__title {
      display: block;
      color: #606266;
      font-weight: bold;
      font-size: 18px !important;
      text-align: center;
    }

    .v-card__text {
      color: #606266;
      font-size: 14px;
      font-weight: bold;
      line-height: 22px;
      padding: 0;
      height: 200px;
      overflow: auto;

      &>div {
        &+div {
          margin-top: 5px;
        }
      }

      & .licence-link {
        color: #1d80dd;
      }
    }

    .v-card__actions {
      margin-top: 20px;
      height: 100px;
      padding: 0 20px;
      display: block;

      .v-btn {
        width: 100%;
        font-size: 16px;
        color: #ffffff;
        margin: 0;

        &+.v-btn {
          margin-top: 10px;
          color: #606266;
        }
      }
    }
  }
}

.privacy-guidelines-think-again-dlg {
  border-radius: 4px;
  margin: 30px;

  &>.v-card {
    padding: 20px 20px 0 20px;

    & .v-card__text {
      color: #606266;
      font-size: 14px;
      font-weight: bold;
      line-height: 22px;
      padding: 0;

      // height: 200px;
      // overflow: auto;
      &>div {
        &+div {
          margin-top: 5px;
        }
      }
    }
  }
}

@media screen and (max-height: 540px) {
  .sign_in {
    &>.eds-copyright {
      position: relative;
      margin-top: 10px;
    }
  }
}
</style>
